// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.ui-drop-down[data-v-536b0453] {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
label[data-v-536b0453] {
  position: relative;
  display: block;
}
select[data-v-536b0453] {
  font-family: var(--primary-font);
  font-size: 1rem;
  line-height: 1.5;
  background-color: transparent;
  border: none;
  display: block;
  width: 100%;
  padding: 0.5rem 1.5rem 0.5rem 1rem;
  color: var(--text-contrast-color);
  outline: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  text-indent: 1px;
  background-position: 100% 100%;
  background-repeat: no-repeat;
  background-size: 200% 1px;
  background-image: linear-gradient(
    to right,
    var(--text-color) 0,
    var(--text-color) 50%,
    var(--input-color) 50%,
    var(--input-color) 100%
  );
  transition: background-position var(--input-time) ease-in-out;
}
.drop-down-name[data-v-536b0453] {
  color: var(--text-contrast-color);
  line-height: 1.5;
  display: block;
  position: absolute;
  top: 0.5rem;
  left: 1rem;
  font-weight: 400;
  pointer-events: none;
  transition: all var(--input-time) ease-in-out;
}
.drop-down-caret[data-v-536b0453] {
  position: absolute;
  right: 0.5rem;
  top: 1rem;
  pointer-events: none;
  width: 0.5rem;
  height: 0.5rem;
  border-bottom: 1px solid var(--input-color);
  border-right: 1px solid var(--input-color);
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
  transition: border-color var(--input-time) ease-in-out;
}
.drop-down-error[data-v-536b0453] {
  font-size: 0.75rem;
  color: var(--error);
  position: absolute;
  bottom: -1rem;
  opacity: 0;
  transition: opacity var(--input-time) ease-in-out;
}
.ui-touched .drop-down-error[data-v-536b0453] {
  opacity: 1;
}
select[data-v-536b0453]:focus {
  background-position: 0 100%;
}
select:focus ~ .drop-down-caret[data-v-536b0453] {
  --input-color: var(--text-color);
}
.not-empty .drop-down-name[data-v-536b0453] {
  font-size: 0.75rem;
  top: -1rem;
  left: 0;
}
.has-error.ui-touched select:focus ~ .drop-down-caret[data-v-536b0453],
.has-error.ui-touched[data-v-536b0453] {
  --input-color: var(--error);
}
.has-error.ui-touched > .drop-down-name[data-v-536b0453] {
  color: var(--error);
}
`, "",{"version":3,"sources":["webpack://./src/components/ui/UiDropDown.vue"],"names":[],"mappings":";AAsEA;EACA,iBAAA;EACA,oBAAA;AACA;AAEA;EACA,kBAAA;EACA,cAAA;AACA;AAEA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,6BAAA;EACA,YAAA;EACA,cAAA;EACA,WAAA;EACA,kCAAA;EACA,iCAAA;EACA,aAAA;EACA,wBAAA;EACA,qBAAA;EACA,gBAAA;EACA,8BAAA;EACA,4BAAA;EACA,yBAAA;EACA;;;;;;GAMA;EACA,6DAAA;AACA;AAEA;EACA,iCAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,gBAAA;EACA,oBAAA;EACA,6CAAA;AACA;AAEA;EACA,kBAAA;EACA,aAAA;EACA,SAAA;EACA,oBAAA;EACA,aAAA;EACA,cAAA;EACA,2CAAA;EACA,0CAAA;EACA,gCAAA;EACA,4BAAA;EACA,wBAAA;EACA,sDAAA;AACA;AAEA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,UAAA;EACA,iDAAA;AACA;AAEA;EACA,UAAA;AACA;AAEA;EACA,2BAAA;AACA;AAEA;EACA,gCAAA;AACA;AAEA;EACA,kBAAA;EACA,UAAA;EACA,OAAA;AACA;AAEA;;EAEA,2BAAA;AACA;AAEA;EACA,mBAAA;AACA","sourcesContent":["<template>\n  <div class=\"ui-drop-down\">\n    <label :class=\"[{ 'not-empty': value, 'has-error': error }, touchedClass]\">\n      <select\n        :value=\"value\"\n        @input=\"$emit('input', $event.target.value)\"\n        @blur=\"lostFocus\"\n      >\n        <option hidden disabled selected />\n        <option v-for=\"item in sortedOptions\" :key=\"item.key\" :value=\"item.key\">\n          {{ item.value }}\n        </option>\n      </select>\n      <span class=\"drop-down-name\">{{ $t(label) }}</span>\n      <i class=\"drop-down-caret\" />\n      <span class=\"drop-down-error\">{{ $t(error) }}</span>\n    </label>\n  </div>\n</template>\n\n<script>\nexport default {\n  name: 'ui-drop-down',\n\n  props: {\n    label: { type: String, default: undefined },\n    value: { type: String, default: undefined },\n    error: { type: String, default: undefined },\n    options: { type: Array, default: undefined },\n    sort: Boolean\n  },\n\n  data() {\n    return {\n      isTouched: false\n    }\n  },\n\n  computed: {\n    touchedClass() {\n      return this.isTouched ? 'ui-touched' : 'ui-untouched'\n    },\n\n    sortedOptions() {\n      if (!this.options) return []\n\n      const mappedOptions = this.options.map((item) => ({\n        key: item.key,\n        value: this.$t(item.value)\n      }))\n\n      if (this.sort && mappedOptions.length > 1) {\n        mappedOptions.sort(({ value: v1 }, { value: v2 }) =>\n          v1?.localeCompare(v2)\n        )\n      }\n\n      return mappedOptions\n    }\n  },\n\n  methods: {\n    lostFocus() {\n      this.isTouched = true\n    }\n  }\n}\n</script>\n\n<style scoped>\n.ui-drop-down {\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n}\n\nlabel {\n  position: relative;\n  display: block;\n}\n\nselect {\n  font-family: var(--primary-font);\n  font-size: 1rem;\n  line-height: 1.5;\n  background-color: transparent;\n  border: none;\n  display: block;\n  width: 100%;\n  padding: 0.5rem 1.5rem 0.5rem 1rem;\n  color: var(--text-contrast-color);\n  outline: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  text-indent: 1px;\n  background-position: 100% 100%;\n  background-repeat: no-repeat;\n  background-size: 200% 1px;\n  background-image: linear-gradient(\n    to right,\n    var(--text-color) 0,\n    var(--text-color) 50%,\n    var(--input-color) 50%,\n    var(--input-color) 100%\n  );\n  transition: background-position var(--input-time) ease-in-out;\n}\n\n.drop-down-name {\n  color: var(--text-contrast-color);\n  line-height: 1.5;\n  display: block;\n  position: absolute;\n  top: 0.5rem;\n  left: 1rem;\n  font-weight: 400;\n  pointer-events: none;\n  transition: all var(--input-time) ease-in-out;\n}\n\n.drop-down-caret {\n  position: absolute;\n  right: 0.5rem;\n  top: 1rem;\n  pointer-events: none;\n  width: 0.5rem;\n  height: 0.5rem;\n  border-bottom: 1px solid var(--input-color);\n  border-right: 1px solid var(--input-color);\n  -webkit-transform: rotate(45deg);\n  -ms-transform: rotate(45deg);\n  transform: rotate(45deg);\n  transition: border-color var(--input-time) ease-in-out;\n}\n\n.drop-down-error {\n  font-size: 0.75rem;\n  color: var(--error);\n  position: absolute;\n  bottom: -1rem;\n  opacity: 0;\n  transition: opacity var(--input-time) ease-in-out;\n}\n\n.ui-touched .drop-down-error {\n  opacity: 1;\n}\n\nselect:focus {\n  background-position: 0 100%;\n}\n\nselect:focus ~ .drop-down-caret {\n  --input-color: var(--text-color);\n}\n\n.not-empty .drop-down-name {\n  font-size: 0.75rem;\n  top: -1rem;\n  left: 0;\n}\n\n.has-error.ui-touched select:focus ~ .drop-down-caret,\n.has-error.ui-touched {\n  --input-color: var(--error);\n}\n\n.has-error.ui-touched > .drop-down-name {\n  color: var(--error);\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
